<template>
    <div class="cz2__modal-popup cz2__modal-popup--tos">
        <div class="cz2__modal-popup__body">
            <focus-lock>
                <div class="cz2__modal-popup__content" tabindex="0">
                    <div class="cz2__modal-popup__header cz2__type__header cz2__tos__header">
                        {{$t('TOS_HEADER')}}

                        <button class="cz2__modal-popup__close" :aria-lable="$t('POPUP_CLOSE')" @click.prevent="close">
                        </button>
                    </div>

                    <div class="cz2__tos__warning">
                        {{$t('TOS_WARNING')}}
                    </div>

                    <div class="cz2__tos__accept">
                        <div class="cz2__tos-accept__checkbox">
                            <input type="checkbox" id="tos__accepted" v-model="accepted">
                        </div>
                        <label class="cz2__tos-accept__label" for="tos__accepted">
                            {{$t('TOS_CHECKBOX')}}
                        </label>
                    </div>

                    <ul class="cz2__tos-conditions">
                        <li v-html="$t('TOS_LINE1')"></li>
                        <li v-html="$t('TOS_LINE2')"></li>
                        <li v-html="$t('TOS_LINE3')"></li>
                        <li v-html="$t('TOS_LINE4')"></li>
                        <li v-html="$t('TOS_LINE5')"></li>
                    </ul>
                </div>
            </focus-lock>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__modal-popup--tos {
            .cz2__modal-popup__body {
                width: calc(100% - 30px);
                max-width: calc(100% - 30px);
                max-height: calc(var(--app-height) - 30px);

                padding: 0;

                overflow: auto;
                -webkit-overflow-scrolling: touch;

                @include respond-above(sm) {
                    width: 626px;
                    max-width: 626px;
                    max-height: none;
                }

                .cz2__modal-popup__content {
                    padding: 0;

                    text-align: left;
                }

                .cz2__tos__header {
                    padding: 20px;
                    padding-right: 110px;

                    color: #c01d1d;

                    border-bottom: 1px solid #dfdfdf;

                    .cz2__modal-popup__close {
                        top: 14px;
                    }
                }

                .cz2__tos__warning {
                    padding: 20px;

                    color: #000;
                    font-family: $font-main;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 18px;
                }

                .cz2__tos__accept {
                    display: flex;

                    padding: 0 20px 20px;
                }

                .cz2__tos-accept__checkbox {
                    flex: 0 0 auto;

                    padding-right: 10px;

                    cursor: pointer;
                }

                .cz2__tos-accept__label {
                    flex: 1 1 auto;

                    color: #000;
                    font-family: $font-main;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 18px;

                    cursor: pointer;
                }

                .cz2__tos-conditions {
                    padding: 0px 20px 20px 46px;
                    margin: 0;

                    li {
                        list-style: disc;

                        margin-bottom: 15px;

                        color: #000;
                        font-family: $font-main;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 18px;
                    }
                }
            }
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    export default {
        components: {
            FocusLock,
        },
        data() {
            return {
                accepted: false,
            };
        },
        watch: {
            accepted() {
                if (this.accepted) {
                    this.confirm();
                }
            },
        },
        methods: {
            close() {
                this.$store.dispatch('showTosConfirmation', null);
            },
            confirm() {
                this.$store.dispatch('showTosConfirmation', null);
                this.$store.dispatch('tosConfirmed');
            },
        },
    };
</script>
